








































































































import { Component, Vue } from 'vue-property-decorator';
import { bus, zirafHTTP } from '@/main'
import BigText from '@/components/BigText.vue'
import GlobalMixins from './mixins';

@Component({
	components: {
		BigText
	}
})
export default class App extends GlobalMixins {
	initComplete = false
	bottomText = ''
	showBottomText = true
	image: string | false = false
	nextButtonEnabled: boolean = false
	hideThanksLogo = true
	privacyOpen: boolean  = false

	get indicatorWidth(): number {
		if (this.$route.name === 'question') {
			if (this.nextButtonEnabled) {
				return ((100 / this.$store.getters.questions.length) * (this.$route.params.questionId ? JSON.parse(this.$route.params.questionId) : 0))
			} else {
				return ((100 / this.$store.getters.questions.length) * ((JSON.parse(this.$route.params.questionId) - 1) ? (JSON.parse(this.$route.params.questionId) - 1) : 0))
			}
		} else if (this.$route.name === 'thanks') {
			return 100
		} else {
			return 0
		}
	}
	get headerLogoHidden() {
		if (this.$route.name === 'question') {
			return true
		} else if (this.$route.name === 'thanks') {
			return this.hideThanksLogo
		} else {
			return false
		}
	}

	closePrivacy(e: any) {
		if (e.target === this.$refs.privacyModal) {
			this.privacyOpen = false
		}
	}

	created() {
		bus.$on('initComplete', () => {
			setTimeout(() => {
				this.initComplete = true
			}, 200)
		})
		bus.$on('setBottomText', (bottomText: string) => {
			if (bottomText === '') {
				this.showBottomText = false

				setTimeout(() => {
					this.bottomText = bottomText
				}, 200)
			}

			if (bottomText && bottomText !== this.bottomText) {
				this.showBottomText = false

				setTimeout(() => {
					this.bottomText = bottomText
					this.showBottomText = true
				}, 200)
			}
		})
		bus.$on('setImage', (image: string | false) => {
			this.image = image
		})
		bus.$on('setQuestionNextButton', (questionFilledIn: boolean) => {
			this.nextButtonEnabled = questionFilledIn
		})
		bus.$on('toggleLogo', (hide: boolean) => {
			this.hideThanksLogo = hide
		})
		bus.$on('scrollToTop', () => {
			setTimeout(() => {
				window.scrollTo(0, 0)
			}, 200)
		})
		bus.$on('togglePrivacy', (state: boolean) => {
			this.privacyOpen = state
		})

		document.addEventListener('keyup', e => {
			if (e.keyCode === 27) {
				this.privacyOpen = false
			}
		})

		zirafHTTP.get('test/questions')
			.then(response => {
				this.$store.dispatch('setQuestions', response.data)
			})
			.catch(error => {
				console.error(error)
			})
	}
}
